import { useEffect } from "react";
import { useContext } from "react";
import { useState } from "react";
import { ClipLoader } from "react-spinners";
import {
  createHighlight,
  getHighlight,
  updateHighlight,
} from "../../../apis/Ambition";
import {
  getHighlightList,
  updateHighlightList,
} from "../../../apis/AmbitionList";
import BootstrapDropdown from "../../../components/BootstrapDropdown";
import { AzilisSwitch, AzilisSwitch2 } from "../../../components/Switch";
import { Textareawithsteroids } from "../ESG/EnvironmentReport";
import { HeaderShow } from "../ESG/ESGmain";
import "../OurCompany/index.css";
import { RelevantGoals } from "./SDGmain";

const TableEmptyRow = () => {
  return (
    <div className="writeinbox__row">
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      <p></p>
    </div>
  );
};

const ScaleRow = ({ whichScale, goal_index, as_is = "as_is" }) => {
  const [scale, setScale] = useState(0);
  const handleGetScale = () => {
    getHighlight({
      key: "goal_" + goal_index + "_" + as_is + "_" + whichScale,
      setValue: setScale,
    });
  };
  const handleUpdateScale = () => {
    updateHighlight({
      key: "goal_" + goal_index + "_" + as_is + "_" + whichScale,
      value: scale,
    });
  };

  useEffect(() => {
    handleGetScale();
  }, [as_is]);
  useEffect(() => {
    if (scale != 0 && scale != "") handleUpdateScale();
  }, [scale]);
  return (
    <>
      <h5>
        <input
          type="radio"
          checked={scale == 1}
          onChange={() => setScale(1)}
          name={whichScale + "_" + goal_index + "_as_is"}
        />
      </h5>
      <h5>
        <input
          type="radio"
          checked={scale == 2}
          onChange={() => setScale(2)}
          name={whichScale + "_" + goal_index + "_as_is"}
        />
      </h5>
      <h5>
        <input
          type="radio"
          checked={scale == 3}
          onChange={() => setScale(3)}
          name={whichScale + "_" + goal_index + "_as_is"}
        />
      </h5>
      <h5>
        <input
          type="radio"
          checked={scale == 4}
          onChange={() => setScale(4)}
          name={whichScale + "_" + goal_index + "_as_is"}
        />
      </h5>
      <h5>
        <input
          type="radio"
          checked={scale == 5}
          onChange={() => setScale(5)}
          name={whichScale + "_" + goal_index + "_as_is"}
        />
      </h5>
    </>
  );
};

const Step5 = () => {
  const [showContent, setShowContent] = useState(false);
  const [financialScale, setFinancialScale] = useState(0);
  const [reputationalScale, setReputationalScale] = useState(0);
  const [regulatorScale, setRegulatorScale] = useState(0);
  const [healthScale, setHealthScale] = useState(0);
  const [safeScale, setSafeScale] = useState(0);
  const [secureScale, setSecureScale] = useState(0);
  const [environmentScale, setEnvironmentScale] = useState(0);
  const [employeeScale, setEmployeeScale] = useState(0);
  const [customerScale, setCustomerScale] = useState(0);
  const [operationalScale, setOperationalScale] = useState(0);
  const [goalIndex, setGoalIndex] = useState(0);
  const { relevantGoals } = useContext(RelevantGoals);

  const subtext = `Choose 3 - 4 SDGs to work on, with specific indicators.

Now we need to find our points to measure on. Data is amazing as it can support so many things: help your company be more transparent, thus comparable and then you can base your business decisions on facts. It can make the difference between goal-washing and true SDG action.

All claims you want to make, needs to be measurably contributing to the SDGs.`;
  const [asIs, setAsIs] = useState("as_is");
  const [debouncedTerm, setDebouncedTerm] = useState(asIs);
  const [loadingAsIs, setLoadingAsIs] = useState("none");
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoadingAsIs("none");
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [loadingAsIs]);

  useEffect(() => {
    setLoadingAsIs("load");
    const timer = setTimeout(() => {
      setAsIs(debouncedTerm);
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [debouncedTerm]);

  const actiontext = `Create assessment metrics, and assign tasks to employees, which contacts etc.`;
  const exercisetext = `What costs are there to realize thhis, manhours gains in terms of goodwill, less waste, education of employees, nature positive, less resource waste, more circularity`;

  return (
    <div className="d-flex flex-column align-items-center mt-2">
      <HeaderShow
        text={"Step 5 Prioritize & Measure"}
        show={showContent}
        setShow={() => setShowContent(!showContent)}
      />
      {showContent ? (
        <>
          <div className="roleambition__bubble w-90 mt-3 ms-0">
            <h5>{subtext}</h5>
            <div className="d-flex justify-content-between mt-2">
              <div className="d-flex flex-column me-5">
                <h5 style={{ textAlign: "center" }}>
                  <b>Action</b>
                </h5>
                <h5>{actiontext}</h5>
              </div>
              <div className="d-flex flex-column">
                <h5 style={{ textAlign: "center" }}>
                  <b>Exercise</b>
                </h5>
                <h5>{exercisetext}</h5>
              </div>
            </div>
          </div>
          <div className="esg__companyinfo d-flex w-90 justify-content-start mt-3 p-0">
            {relevantGoals && relevantGoals.length > 0 ? (
              <BootstrapDropdown
                goals={relevantGoals}
                name={(goal) => {
                  return goal?.key?.replace("_", " ");
                }}
                setImportantVar={setGoalIndex}
              />
            ) : null}

            <h4 className="ms-4">
              {" "}
              {relevantGoals[goalIndex] ? relevantGoals[goalIndex].title : null}
            </h4>
          </div>

          {Array.isArray(relevantGoals) &&
            relevantGoals.map((goal, i) => {
              if (goalIndex != i) {
              } else if (goalIndex == i)
                return (
                  <div className="step5__table w-90 pt-3">
                    <div className="w-30 mt-3 d-flex position-relative">
                      <div className="w-100">
                        <AzilisSwitch2
                          styleNo={"sdg"}
                          choice1={"As is"}
                          choice2={"To be"}
                          value1={"as_is"}
                          value2={"to_be"}
                          which={debouncedTerm}
                          setWhich={setDebouncedTerm}
                        />
                      </div>
                      <div
                        className="ms-4 my-auto position-absolute"
                        style={{ right: "-20%", top: "25%" }}
                      >
                        {loadingAsIs === "load" ? (
                          <ClipLoader color="#F2F8F0" size={20} />
                        ) : null}
                      </div>
                    </div>
                    <div className="writeinbox__table  mb-3 w-100 mt-3">
                      <div className="writeinbox__header">
                        <h5>
                          <b>Loss/Gain Capital Earning</b>
                        </h5>
                        <h5>Incidental</h5>
                        <h5>Minor</h5>
                        <h5>Moderate</h5>
                        <h5>Major</h5>
                        <h5>Extreme</h5>
                      </div>

                      <div className="writeinbox__body">
                        <TableEmptyRow />
                        <div className="writeinbox__row">
                          <h5>Financially</h5>
                          <ScaleRow
                            as_is={asIs}
                            goal_index={i}
                            whichScale={"Financially"}
                            setScale={setFinancialScale}
                            scale={financialScale}
                          />
                        </div>
                        <TableEmptyRow />
                        <div className="writeinbox__row">
                          <h5>Reputationally</h5>
                          <ScaleRow
                            as_is={asIs}
                            goal_index={i}
                            whichScale={"Reputationally"}
                            setScale={setReputationalScale}
                            scale={reputationalScale}
                          />
                        </div>
                        <TableEmptyRow />
                        <div className="writeinbox__row">
                          <h5>Regulatory</h5>
                          <ScaleRow
                            as_is={asIs}
                            goal_index={i}
                            whichScale={"Regulatory"}
                            setScale={setRegulatorScale}
                            scale={regulatorScale}
                          />
                        </div>
                        <TableEmptyRow />
                        <div className="writeinbox__row">
                          <h5>Health</h5>
                          <ScaleRow
                            as_is={asIs}
                            goal_index={i}
                            whichScale={"Health"}
                            setScale={setHealthScale}
                            scale={healthScale}
                          />
                        </div>
                        <TableEmptyRow />
                        <div className="writeinbox__row">
                          <h5>Safety</h5>
                          <ScaleRow
                            as_is={asIs}
                            goal_index={i}
                            whichScale={"Safety"}
                            setScale={setSafeScale}
                            scale={safeScale}
                          />
                        </div>
                        <TableEmptyRow />
                        <div className="writeinbox__row">
                          <h5>Security</h5>
                          <ScaleRow
                            as_is={asIs}
                            goal_index={i}
                            whichScale={"Security"}
                            setScale={setSecureScale}
                            scale={secureScale}
                          />
                        </div>
                        <TableEmptyRow />
                        <div className="writeinbox__row">
                          <h5>Environmental</h5>
                          <ScaleRow
                            as_is={asIs}
                            goal_index={i}
                            whichScale={"Environmental"}
                            setScale={setEnvironmentScale}
                            scale={environmentScale}
                          />
                        </div>
                        <TableEmptyRow />
                        <div className="writeinbox__row">
                          <h5>Customer</h5>
                          <ScaleRow
                            as_is={asIs}
                            goal_index={i}
                            whichScale={"Customer"}
                            setScale={setCustomerScale}
                            scale={customerScale}
                          />
                        </div>
                        <TableEmptyRow />
                        <div className="writeinbox__row">
                          <h5>Operational</h5>
                          <ScaleRow
                            as_is={asIs}
                            goal_index={i}
                            whichScale={"Operational"}
                            setScale={setOperationalScale}
                            scale={operationalScale}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                );
            })}
        </>
      ) : null}
    </div>
  );
};

export default Step5;
